var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-brief py-4"},[_c('addons'),_c('hr'),_c('requirements')],1)}
var staticRenderFns = []

export { render, staticRenderFns }